import { isWeddingRingJewelryProperty } from '@merchant-backend/util'

// 处理旅拍目的地选中项的
// Step One 选中的目的地区域id，国内or国外
export const checkoutArea = (list, form) => {
  if (list && list.length) {
    const list1 = list.find(item => item.id == '3377')
    const list2 = list.find(item => item.id == '3421')
    let id = ''
    if (list1 && list1.children.some(item => item.isActive)) {
      id = '3377'
    }
    if (list2 && list2.children.some(item => item.isActive)) {
      id = '3421'
    }
    if (id) {
      form.setFieldsValue({ destination: 1 })
    }
    return id
  }
}

export const getText = isSingle => {
  if (isSingle) {
    return '单品'
  } else {
    return isWeddingRingJewelryProperty() ? '商品' : '套餐'
  }
}
